import queryString from "query-string";
import { useLocation, useParams } from "react-router-dom";

type InputParams = { projectId: number; workspaceId: number };
type RouterParams = { project: string; dashboard: string };
export function useCurrentProjectAndWorkspaceFromParams(
  inputParams?: Partial<InputParams>
): InputParams {
  const routerParams = useParams<Partial<RouterParams>>();
  const { search } = useLocation();
  const query = queryString.parse(search);
  return {
    projectId: inputParams
      ? inputParams?.projectId
      : routerParams && routerParams.project
      ? parseInt(routerParams.project)
      : null,
    workspaceId: inputParams
      ? inputParams?.workspaceId
      : routerParams && routerParams.dashboard
      ? parseInt(routerParams.dashboard)
      : query?.workspaceId
      ? parseInt(query.workspaceId as string)
      : null,
  };
}
